import { render } from "./BoardCategory.vue?vue&type=template&id=66592e62&scoped=true"
import script from "./BoardCategory.vue?vue&type=script&lang=js"
export * from "./BoardCategory.vue?vue&type=script&lang=js"

import "./BoardCategory.vue?vue&type=style&index=0&id=66592e62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66592e62"]])

export default __exports__